import React from 'react';
import './App.css';
import './index.css'
import OverallRoutes from './Route/routing';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <>
      <ToastContainer />
      <OverallRoutes />
    </>
  );
}

export default App;
